module.exports = __webpack_public_path__ + "static/media/spot8.2562c87f.webp";